export default {
  UPDATE_DATA: 'UPDATE_DATA',
  RESET_DATA: 'RESET_DATA',
};
